//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import Utils from "../services/Utils.js";

const MixpanelEvent = class MixpanelEvent {
  constructor(title, eventType = null, category = null, innerTitle = null) {
    this.id = Utils.generateUuidV4();
    this.title = title;
    this.eventType = eventType;
    this.category = category;
    this.innerTitle = innerTitle;
  }
};

export default MixpanelEvent;
